import Badge from '../../components/Badge'
import { useEffect, useState } from "react";
import { BsCaretDownFill, BsCaretUpFill } from 'react-icons/bs'
import {
  BiCheck,
  BiCheckDouble
} from 'react-icons/bi'
import { 
  formatNumber,
  formatDateFromUnix
} from '../../utilities/Format'
import { convertJson } from '../../utilities/Validate'

import { format, parse } from 'date-fns'
import { Documents, OrderStatusDisplay, OrderStatusTheme, DivisionTheme } from '../../constants/Enum'
import { Division } from '../../constants/EnumType'
import Modal from "../../components/Modal";

import Select from 'react-select'

import { OrderType } from '../../models'

const ProductionOrderHeader = ({
  id, productionOrder, title, divisionOnChanged, onStatusChanged, onBatchChanged, readOnly = false, picklist, clearSelectStatus, setClearSelectStatus
}) => {
  const [ collape, setCollape ] = useState(false);
  const [ openEditBatch, setOpenEditBatch ] = useState(false);
  const [ updatedBatches, setUpdatedBatches ] = useState([])

  const thaiDueDate = productionOrder && productionOrder.dueDate ?
    format(parse(productionOrder.dueDate, 'yyyy-MM-dd', new Date()), 'dd.MM.yyyy') : ''

  const [tempSelectStatus, setTempSelectStatus] = useState(null)
  useEffect(() => {
    // not allow manual use current status
    // if(tempSelectStatus && productionOrder && tempSelectStatus.value && productionOrder.statusFromApp && tempSelectStatus.value !== productionOrder.statusFromApp){
    // allow manual use current status
    if(tempSelectStatus && productionOrder && tempSelectStatus.value && productionOrder.statusFromApp){
      onStatusChanged(tempSelectStatus.value)
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tempSelectStatus]);

  useEffect(() => {
    if(clearSelectStatus){
      setClearSelectStatus(false)
      setTempSelectStatus(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearSelectStatus]);
  
  useEffect(() => {
    if (productionOrder) {
      let batchNumbers = []
      if (productionOrder.actualBatchNumbers) {
        const actualBatchNumbers = convertJson(productionOrder.actualBatchNumbers)

        const originalBatch = convertJson(productionOrder.batchNumbers)

        actualBatchNumbers.forEach(batch => {
          const sixLastDigit = batch.slice(-6)
          const matchSuffix = originalBatch.find(b => b.slice(-6) === sixLastDigit)
          if (matchSuffix) batchNumbers.push(batch)
        })

        originalBatch.forEach(origin => {
          if (!batchNumbers.map(b => b.slice(-6)).includes(origin.slice(-6))) batchNumbers.push(origin)
        })

        batchNumbers = [...new Set(batchNumbers)]
      } else if (productionOrder.batchNumbers) {
        batchNumbers = convertJson(productionOrder.batchNumbers)
      }
      setUpdatedBatches(batchNumbers)
    }
  }, [ productionOrder ])

  let listEditSAP = []
  if (productionOrder && productionOrder.countEditWorkCenter && productionOrder.countEditWorkCenter > 0) {
    listEditSAP.push('Work Center')
  }
  if (productionOrder && productionOrder.countEditOperation && productionOrder.countEditOperation > 0) {
    listEditSAP.push('Operation')
  }

  const showVersion = (releaseNo) => {
    if (Number.isNaN(releaseNo) || Number.parseInt(releaseNo) <= 1) return ''

    return <h5><Badge variant="warning">Release {Number.parseInt(productionOrder.releaseNo)}</Badge></h5>
  }

  const showDivision = (division) => {
    if (productionOrder && title === Documents.PRODUCTION_PROCESS_CONFIRM && readOnly === false) {
      return <select title='select'
        value={productionOrder.division}
        className='p-1 border border-gray-400 rounded-md'
        onChange={divisionOnChanged}
        onKeyDown={(e) => e.stopPropagation()}
      >
        {Object.keys(Division).map( division => <option key={division} value={division}>{division}</option>)}
      </select>
    }
    return <Badge variant={DivisionTheme[division]}>{division}</Badge>
  }

  const showProductProfiles = (order) => {
    return <div className='flex flex-wrap gap-1'>
      {order.infoFwt && <Badge variant='product-info'>{order.infoFwt}</Badge>}
      {order.infoEffBulkDate && <Badge variant='product-info'>Eff.Bulk : {order.infoEffBulkDate}</Badge>}
      {order.infoRefPkg && <Badge variant='product-info'>{order.infoRefPkg}</Badge>}
      {order.infoPallet && <Badge variant='product-info'>Pallet: {order.infoPallet}</Badge>}
      {order.infoPacking && <Badge variant='product-info'>Packing: {order.infoPacking}</Badge>}
    </div>
  }

  const showOrderStatusOption = () => {
    if (productionOrder && title === Documents.PRODUCTION_PROCESS_CONFIRM && readOnly === false) {
      return <Select
        menuPortalTarget={document.body}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        onChange={setTempSelectStatus}
        className="ml-2"
        value={tempSelectStatus ? tempSelectStatus : { value: productionOrder.statusFromApp, label: OrderStatusDisplay[productionOrder.statusFromApp] }}
        options={Object.keys(OrderStatusDisplay).filter(sts => sts !== 'ALL').map(key => {
          return { value: key, label: OrderStatusDisplay[key] }
        })}
        isSearchable={false}
      />
    }
    return ''
  }

  const onChanged = (e) => {
    let currentBatches = e.target.value.split(', ')
    setUpdatedBatches(currentBatches)
  }

  const isTrialBatch = productionOrder && productionOrder.trialBatch
  const isBulk = id.startsWith('8')

  return <div>
    <div className='grid grid-cols-1 sm:text-center sm:grid-cols-3'>
      <div className='flex items-center gap-2'>
        <h5>#{id}</h5>
        {productionOrder && <h5><Badge variant={OrderStatusTheme[productionOrder.statusFromApp]}>{OrderStatusDisplay[productionOrder.statusFromApp]}</Badge></h5>}
      </div>
      <h3>{title}</h3>
      <div className='flex justify-end'>
        {showVersion(productionOrder.releaseNo)}
        {showOrderStatusOption()}
      </div>
    </div>
    {isTrialBatch ? <h5 className='mb-1 '><Badge variant='text-white font-bold bg-yellow-500 text-xs'>{productionOrder.trialBatch}</Badge></h5> : null }
    {productionOrder && productionOrder.orderType === OrderType.CLAIM &&
      <h6><Badge variant={` text-white bg-red-500`}>{productionOrder.orderType}{productionOrder.alternativeText ? ` - ${productionOrder.alternativeText}` : ''}</Badge></h6>}
    {productionOrder && productionOrder.orderType === OrderType.REPACK &&
      <h6><Badge variant={` text-white bg-blue-500`}>{productionOrder.orderType}{productionOrder.alternativeText ? ` - ${productionOrder.alternativeText}` : ''}</Badge></h6>}
    <div className={`grid gap-1 grid-cols-1 sm:grid-cols-3 transition-all duration-700${
        collape ? ' max-h-0 overflow-hidden' : ' max-h-36 overflow-auto'
      }`}>
      <div className='flex col-span-2'>
        <h6 className='font-bold basis-1/4'>Material</h6>
        <div className='flex basis-3/4'>
          {productionOrder ? <div>
              <h6>{productionOrder.materialDescription} ({productionOrder.materialCode}) {productionOrder.barcodeFgCase ? `(${productionOrder.barcodeFgCase})` : null} {showDivision(productionOrder.division)}</h6>
              {showProductProfiles(productionOrder)}
            </div> : null}
        </div>
      </div>
      <div className='flex'>
        <h6 className='font-bold basis-1/4 sm:basis-2/4 lg:basis-1/3'>Order Qty.</h6>
        {productionOrder ? <h6 className='basis-3/4 sm:basis-2/4 lg:basis-2/3'>{formatNumber(productionOrder.orderQty)} {productionOrder.materialUnit}</h6> : null}
      </div>
      <div className='flex col-span-2'>
        <h6 className='font-bold basis-1/4'>Batch No</h6>
        <h6 className="basis-3/4">{updatedBatches.join(', ')}
          <button onClick={() => setOpenEditBatch(true)} className={`${title === Documents.PRODUCTION_PROCESS_CONFIRM && readOnly === false ? ' inline-block':'hidden'} ml-2 work-center-edit`}>แก้ไข</button>
        </h6>
      </div>
      <div className='flex'>
        <h6 className='font-bold basis-1/4 sm:basis-2/4 lg:basis-1/3'>Due Date</h6>
        <h6 className='basis-3/4 sm:basis-2/4 lg:basis-2/3'>{thaiDueDate}</h6>
      </div>
      <div className={title === Documents.PRODUCTION_PROCESS_CONFIRM ? 'flex col-span-2' : 'hidden'}>
        <h6 className='font-bold basis-1/4'>ต้องแก้ไขใน SAP</h6>
        {listEditSAP.length === 0 ? '' : <h6 className='basis-3/4'>{listEditSAP.join(', ')}</h6>}
      </div>
      <div className={title === Documents.PRODUCTION_PROCESS_CONFIRM ? 'flex' : 'hidden'}>
        <h6 className='font-bold basis-1/4 sm:basis-2/4 lg:basis-1/3'>บันทึกข้อมูลเมื่อ</h6>
        <h6 className='basis-3/4 sm:basis-2/4 lg:basis-2/3'>{format(new Date(productionOrder.updatedAt), 'dd.MM.yyyy HH:mm')}</h6>
      </div>
      {isBulk ? <div className='flex col-span-2'>
        <h6 className='font-bold basis-1/4'>PD ตรวจ RM โดย</h6>
        <div className='basis-3/4'>
          {picklist?.checkedDateTime > 0 ? 
            <h6 className='flex items-center gap-1 text-green-700'><BiCheck color='green' size={20}/>{picklist?.checkedBy} <span className='text-xs italic text-muted'>({formatDateFromUnix(picklist.checkedDateTime)})</span></h6>:
            <h6 className='italic text-red-500 '>ไม่ได้ตรวจ</h6>}
        </div>
      </div> : null}
      {isBulk ? <div className='flex'>
        <h6 className='font-bold basis-1/4 sm:basis-2/4 lg:basis-1/3'>ตรวจ RM โดย Mixing</h6>
        <div className='basis-3/4 sm:basis-2/4 lg:basis-2/3'>
          {picklist?.qualityCheckedDateTime > 0 ? 
            <h6 className='flex flex-col text-green-700'>
              <span className='flex items-center gap-1'><BiCheckDouble color='green' size={20}/>{picklist?.qualityCheckedBy}</span>
              <span className='text-xs italic text-muted'>({formatDateFromUnix(picklist.qualityCheckedDateTime)})</span>
            </h6>
            : <h6 className='italic text-red-500'>ไม่ได้ตรวจ</h6>
          }
        </div>
      </div> : null}
    </div>
    <div className='relative mt-2 mb-5'>
      <span className=' absolute border-b border-[#f0f0f0] w-full align-middle'></span>
      <button className='absolute px-5 bg-gray-200 rounded hover:shadow-md top-1/2 left-1/2 -translate-x-2/4 -translate-y-2/4'
        onClick={() => setCollape(!collape)}
      >
        {collape ? <BsCaretUpFill color="grey"/> : <BsCaretDownFill color="grey"/>}
      </button>
    </div>
    <Modal
      show={openEditBatch} title='แก้ไข Batch No'
      cancelText='ยกเลิก'
      onHide={() => setOpenEditBatch(false)}
      okAction={() => {
        onBatchChanged(updatedBatches)
        setOpenEditBatch(false)
      }}
      okText='ยืนยัน'>
        <div className='flex flex-col gap-2'>
          <input 
            type="text" 
            value={updatedBatches.join(', ')}
            onChange={onChanged}
            className='input-form-text'>
          </input>
        </div>
    </Modal>
  </div>
}
 
export default ProductionOrderHeader